import React from 'react';
import './index.less';
import { Popover, PopoverProps } from 'antd';



const prefix = 'common-popover';
const CommonPopover: React.FC<PopoverProps> = (props) => {
  return (
    <Popover {...props} rootClassName={`${prefix}`}>
    </Popover>
  );
};

export default CommonPopover;
